/// <reference path="../../TypeLite.Net4.d.ts" />
import * as React from 'react'
import * as ReactDom from 'react-dom'

export interface IServiceImageProps {
	image: SkodaAuto.Marvin.ServiceAvailability.Web.App.Models.Data.ServiceMediaModel,
}

export interface IServiceImageState {

}

export class ServiceImage extends React.Component<IServiceImageProps, IServiceImageState>
{
	constructor(props: IServiceImageProps) {
		super(props);
	}

	public render(): JSX.Element {
		if (!this.props.image)
			return null;

		return (
			<div className="col-xl-24 col-lg-24 col-md-12 col-md-24 col-sm-24 image-item-container position-col-reset">
				<img src={this.props.image.Url} alt={this.props.image.Title} />
				<p>{this.props.image.Description}</p>
			</div>
		);
	}
}